import axios from 'axios';
import { Config } from '../config';
import userStore from "../store/userStore";
import getHeaders from './header';

const urlStarter = Config[Config.env].functionappurl;

/**
 * pushes whatever feedback the user left
 * @param {*} feedbackObject object with all the feedback data taking from feedback page
 */
export function sendFeedback(feedbackObject) {
    return new Promise(async(resolve, reject) => {
        const body = {
            ...feedbackObject,
            user: userStore.user.id,
            company: userStore.user.company
        }
        const headers = await getHeaders(); 

        let url = urlStarter + `api/feedback`;
        axios.post(url,body ,{ headers: headers }).then((response) => {
            resolve(response.data);
        }).catch((e) => {
            reject(e);
        });
    });
}


// WEBPACK FOOTER //
// ./src/services/feedbackManager.js